/**
 * Languages bar
 */

const countryActivators = document.querySelectorAll(".country-navigator");
const selectorsList = document.querySelectorAll(".country-navigator, .lang-bar-overlay, .country-switcher-nav");
for (const countryActivator of countryActivators) {
    countryActivator.addEventListener("click", (e) => {
        e.preventDefault();
        for (let i = 0; i < selectorsList.length; i++) {
            selectorsList[i].classList.toggle("active");
        }
    });
}

function hideLanguagesBar(e) {
    e.preventDefault();
    for (let i = 0; i < selectorsList.length; i++) {
        selectorsList[i].classList.remove("active");
    }
}

if (document.querySelector(".country-switcher-nav .close-btn") !== null) {
    document.querySelector(".country-switcher-nav .close-btn").addEventListener("click", hideLanguagesBar);
}

if (document.querySelector(".lang-bar-overlay") !== null) {
    document.querySelector(".lang-bar-overlay").addEventListener("click", hideLanguagesBar);
}
